import OperationsView from '../../pages/OperationsView';

// Nome simples (PT): Página de Operações
export default function PaginaOperacoes(props) {
  return <OperationsView {...props} />;
}






